export default __webpack_public_path__ + "static/media/folic-acid.77050912.jpg";